import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Typography } from '@material-ui/core';
import avatar from '../../../../../../assets/images/avatar1.png';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import orgLogo from './../../../../../../assets/images/org_avatar.png'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: theme.spacing(1)
  }
}));

const Profile = props => {
  const { className, profile, organization, ...rest } = props;

  const classes = useStyles();

  // const user = {
  //   name: 'DR. John Smith MD.',
  //   bio: 'Medical Director'
  // };

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      {/* <Avatar
        alt="Person"
        className={classes.avatar}
        component={RouterLink}
        src={orgLogo}
      /> */}
      <img
        src={
          organization && organization.ehrLogoFileURI
            ? organization.ehrPublicLogoURL
            : orgLogo
        }
        style={{ height: '100px', width: '100px' }}
      />
      <Typography className={classes.name} variant="h4">
        {(profile && profile.firstname ? profile.firstname : '') +
          ' ' +
          (profile && profile.lastname ? profile.lastname : ' ') +
          ' ' +
          (profile && profile.title ? profile.title : '')}
      </Typography>
      {/* <Typography variant="body2">{user.bio}</Typography> */}
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string
};
const mapStateToProps = state => ({

  organization: state.ehr && state.ehr.organization
});
export default withRouter(
  connect(mapStateToProps)((Profile))
);

//export default Profile;
